import { RARITY_CONFIG } from '@/constants/rewards';
import type { Rarity } from '@/types/rewards';

interface ProbabilityBarsProps {
  pool: Record<Rarity, number>;
}

const RARITY_ORDER: Rarity[] = ['common', 'uncommon', 'rare', 'epic', 'legendary'];

export function ProbabilityBars({ pool }: ProbabilityBarsProps) {
  return (
    <div className="flex flex-col gap-1.5">
      {RARITY_ORDER.map((rarity) => {
        const weight = pool[rarity];
        if (!weight || weight === 0) return null;
        const config = RARITY_CONFIG[rarity];
        const pct = Math.round(weight * 100);

        return (
          <div key={rarity} className="flex items-center gap-2 text-xs">
            <span
              className="h-2 w-2 shrink-0 rounded-full"
              style={{ backgroundColor: config.color }}
            />
            <span className="w-[72px] text-stone-500">{config.label}</span>
            <div className="flex-1 h-1.5 rounded-full bg-stone-100 overflow-hidden">
              <div
                className="h-full rounded-full transition-all"
                style={{ width: `${pct}%`, backgroundColor: config.color }}
              />
            </div>
            <span className="w-8 text-right tabular-nums text-stone-400">{pct}%</span>
          </div>
        );
      })}
    </div>
  );
}
